"use strict";

export var D5SnackbarsConstants = {
  SHOW_SNACKBAR: 'SHOW_SNACKBAR'
};